/**
 * Columns shown in the services list table (ServicesTable.vue).
 * Part of the persisted "directory" configuration (key: serviceTableColumns);
 * override it to add/remove/reorder columns from the Services entity.
 *
 * `column` is a dotted path resolved against each service row, e.g.
 * "unitCost" or "service_providers.name" (dotted paths through the
 * `service_providers` REF reach real fields on the ServiceProviders record,
 * such as `research_infrastructure`). Use `type: "mref"` for a REF/REF_ARRAY
 * field (e.g. serviceTypes) to join every item's label (or name) with a
 * comma; the query selection for such a column is expanded to fetch both
 * `label` and `name` automatically.
 *
 * `parentBiobankName` / `parentBiobankId` are synthetic fields injected by
 * biobanksStore (not real Services columns, not fetched via this config) —
 * they're always available (needed internally for cart grouping) and remain
 * a valid column choice even though they're no longer part of the default.
 *
 * Defaults target the isidore-acc-v13 model.
 */
export const initialServiceTableColumns = [
  { label: "Service Name", column: "name" },
  { label: "Research Infrastructure", column: "service_providers.research_infrastructure" },
  { label: "Service Type", column: "serviceTypes", type: "mref" },
  { label: "Device", column: "device" },
  { label: "Unit Cost", column: "unitCost" },
  { label: "Unit Theme", column: "unitTheme" },
  { label: "Description", column: "description" },
];

export default initialServiceTableColumns;
